import { stateTypes, StoredOrderDetailType } from "../types";
import { checkoutAppId } from "../settings/appDefaults";
import { getQueryParam, retrieveOrderDetailLocalStorage } from "../helpers";
import appSettings from "../settings/appSettings";

const checkIsThankyouStepBasedQueryString = () => {
  const orderId = getQueryParam("order_id");
  return !!orderId;
};

const isThankyouStep = checkIsThankyouStepBasedQueryString();

const hydrateStateFromLocalStorage = (orderId) => {
  const orderFromLS = retrieveOrderDetailLocalStorage(orderId);

  // Fallback to window.wvusFlexCheckoutSettings.orderData when localStorage is empty
  // This handles incognito mode where localStorage is isolated
  const orderFromWindow = appSettings.orderData as StoredOrderDetailType | undefined;
  const orderData = orderFromLS || orderFromWindow;

  const eventData = orderData?.eventData || appSettings.eventData;

  if (orderData) {
    // Enrich order data with event fields if missing
    // Also ensure orderId/orderRef are populated from URL params if missing
    const enrichedOrderData: StoredOrderDetailType = {
      ...orderData,
      orderId: orderData.orderId || orderId,
      orderRef: orderData.orderRef || getQueryParam("order_key"),
      signUpEndDate: orderData.signUpEndDate || eventData?.SignupEndDate,
      photoType: orderData.photoType || eventData?.PhotoType?.toLowerCase(),
      eventData: orderData.eventData || eventData
    };

    return {
      ...initialState,
      step1: {
        titlePhraseKey: "photo_first.step1",
        enabled: false,
        visible: false
      },
      step2: {
        titlePhraseKey: "photo_first.step2",
        enabled: false,
        visible: false,
        checkoutExpanded: false
      },
      thankYouStep: {
        enabled: true,
        visible: true
      },
      currentOrder: enrichedOrderData,
      eventData
    } as stateTypes;
  } else if (!isThankyouStep) {
    history.replaceState({}, window.document.title, window.location.pathname);
  }

  return initialState;
};

const determineInitialState = () => {
  const orderId = getQueryParam("order_id");

  if (orderId) {
    return hydrateStateFromLocalStorage(orderId);
  }

  return initialState;
};

const initialState: stateTypes = {
  appId: checkoutAppId,
  checkoutFlow: appSettings?.checkoutFlow || "PhotoFirst",
  products: [],
  address: {
    line1: "",
    line2: "",
    city: "",
    state: "",
    zip: ""
  },
  orderPayload: {},
  orderResp: null,
  orderErrorResp: [],
  step1: {
    titlePhraseKey: "photo_first.step1",
    enabled: !isThankyouStep,
    visible: !isThankyouStep
  },
  step2: {
    titlePhraseKey: "photo_first.step2",
    enabled: false,
    visible: !isThankyouStep,
    checkoutExpanded: false
  },
  thankYouStep: {
    enabled: isThankyouStep,
    visible: isThankyouStep
  },
  moderatedSelfieData: null,
  appOverlayActive: false,
  submitMessagePhraseKey: "",
  eventData: {
    ...(appSettings?.eventData || {})
  },
  cobrand: appSettings?.wvusCobrand || appSettings?.eventData?.CobrandCode || ""
};

export default initialState;

export { hydrateStateFromLocalStorage, determineInitialState, initialState };
